import {
    FETCH_CLEAR, FETCH_FAILURE, FETCH_LOAD, FETCH_REQUEST, FETCH_SUCCESS, FetchClearAction,
    FetchFailureAction, FetchInitAction, FetchRequestAction, FetchSuccessAction
} from '../fetch-middleware.types';

export function isFetchLoadAction (
    name: string,
    action: any
): action is FetchInitAction {
    return action.type === getFetchLoadActionType(name);
}

export function getFetchLoadActionType (name: string): string {
    return `${FETCH_LOAD}_${name}`;
}

export function isFetchSuccessAction<TData=any> (
    name: string,
    action: any
): action is FetchSuccessAction<TData> {
    return action.type === getFetchSuccessActionType(name);
}

export function getFetchSuccessActionType (name: string): string {
    return `${FETCH_SUCCESS}_${name}`;
}

export function isFetchFailureAction (
    name: string,
    action: any
): action is FetchFailureAction {
    return action.type === getFetchFailureActionType(name);
}

export function getFetchFailureActionType (name: string): string {
    return `${FETCH_FAILURE}_${name}`;
}

export function isFetchClearAction (
    name: string,
    action: any
): action is FetchFailureAction {
    return action.type === getFetchClearActionType(name);
}

export function getFetchClearActionType (name: string): string {
    return `${FETCH_CLEAR}_${name}`;
}

export function clearFetchData (name: string): FetchClearAction {
    return { type: getFetchClearActionType(name) };
}

export function isFetchRequestAction (
    action: any
): action is FetchRequestAction {
    return action.type === FETCH_REQUEST;
}
